import { $api } from "../AxiosInstance";

export class AnalyticsService {
  static async getGa4HistoryOrders(params) {
    return await $api.post("/api/admin/ga4/request/history/query", {
      ...params,
      page: params.page - 1,
    });
  }

  static async getGa4HistoryById(id) {
    return await $api.get("/api/admin/ga4/request/history/byId", {
      params: { id },
    });
  }
}
